import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ServiceTierCard = ({ tier, isPopular = false }) => {
  return (
    <div className={`relative bg-white rounded-xl border-2 transition-all duration-300 hover:shadow-executive-lg ${
      isPopular 
        ? 'border-brand-primary shadow-executive' 
        : 'border-gray-200 hover:border-brand-primary/30'
    }`}>
      {isPopular && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <div className="bg-brand-primary text-white px-4 py-1 rounded-full text-sm font-medium">
            Most Popular
          </div>
        </div>
      )}
      <div className="p-8">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h3 className="text-2xl font-bold text-text-primary mb-2">{tier?.name}</h3>
            <p className="text-text-secondary">{tier?.subtitle}</p>
          </div>
          <div className={`w-16 h-16 rounded-lg flex items-center justify-center ${
            isPopular ? 'bg-brand-primary' : 'bg-brand-surface'
          }`}>
            <Icon 
              name={tier?.icon} 
              size={32} 
              color={isPopular ? 'white' : 'var(--color-brand-primary)'} 
            />
          </div>
        </div>

        <div className="mb-6">
          <div className="text-3xl font-bold text-text-primary mb-2">
            {tier?.pricing}
          </div>
          <p className="text-sm text-text-secondary">{tier?.pricingNote}</p>
        </div>

        <div className="mb-8">
          <h4 className="font-semibold text-text-primary mb-4">What's Included:</h4>
          <ul className="space-y-3">
            {tier?.features?.map((feature, index) => (
              <li key={index} className="flex items-start space-x-3">
                <Icon 
                  name="Check" 
                  size={20} 
                  color="var(--color-success)" 
                  className="mt-0.5 flex-shrink-0" 
                />
                <span className="text-text-secondary">{feature}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mb-6">
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-text-secondary">Timeline:</span>
              <div className="font-medium text-text-primary">{tier?.timeline}</div>
            </div>
            <div>
              <span className="text-text-secondary">Team Size:</span>
              <div className="font-medium text-text-primary">{tier?.teamSize}</div>
            </div>
          </div>
        </div>

        <Button
          variant={isPopular ? "default" : "outline"}
          fullWidth
          className={isPopular ? "bg-brand-primary hover:bg-brand-primary/90" : ""}
          iconName="ArrowRight"
          iconPosition="right"
        >
          {tier?.ctaText}
        </Button>
      </div>
    </div>
  );
};

export default ServiceTierCard;